import { makeAutoObservable, observable } from "mobx";

import { CloseAction as action } from "../shared/snackbarActions";

const initialState: any[] = [];

class SnackbarStore {
  @observable notifications = initialState;

  constructor() {
    makeAutoObservable(this);
  }

  enqueueSnackbar(note: any) {
    this.notifications.push({
      key: new Date().getTime() + Math.random(),
      ...note,
    });
  }

  removeSnackbar(targetKey: any) {
    this.notifications = this.notifications.filter(
      ({ key }) => key !== targetKey
    );
  }

  info(msg: string) {
    this.enqueueSnackbar({
      message: `${msg}`,
      options: {
        variant: "info",
        action,
      },
    });
  }

  success(msg: string) {
    this.enqueueSnackbar({
      message: `${msg}`,
      options: {
        variant: "success",
        action,
      },
    });
  }

  warning(msg: string) {
    this.enqueueSnackbar({
      message: `${msg}`,
      options: {
        variant: "warning",
        action,
      },
    });
  }

  error(msg: string) {
    this.enqueueSnackbar({
      message: `${msg}`,
      options: {
        variant: "error",
        action,
      },
    });
  }
}

export default SnackbarStore;
